(function () {
  'use strict';

  const ACTIVE_BG = '#007aff';

  // Puntos por opción (índice 0-3) para cada pregunta.
  // null = la pregunta no puntúa para el nivel.
  const SCORING = [
    [3, 2, 1, 0], // Q1 frecuencia de uso
    [3, 2, 1, 2], // Q2 actividad física
    [2, 2, 2, 3], // Q3 situaciones de sudor
    [3, 2, 1, 2], // Q4 problema actual
    null,         // Q5 zona del cuerpo (no puntúa)
    null,         // Q6 resultado deseado (no puntúa)
    null          // Q7 prioridad (no puntúa)
  ];

  const MIN_WIDTH = 8; // % mínimo para que la barra nunca se vea vacía

  function initQuiz(quiz) {
    if (quiz.dataset.quizInit) return;
    quiz.dataset.quizInit = 'true';

    const questions = quiz.querySelectorAll('.custom-quiz-quiestion');
    const stepper = quiz.querySelector('.custom-quiz-stepper');
    const nextBtn = quiz.querySelector('.custom-quiz-actions-next');
    const paginationEl = quiz.querySelector(
      '.custom-quiz-actions-pagination p, .custom-quiz-actions-pagination'
    );

    if (!questions.length || !nextBtn) return;

    const total = questions.length;
    let current = 0;
    const answers = {}; // { qIndex: { index, text } }

    // --- Stepper dinámico (clona segmentos hasta igualar # de preguntas) ---
    let steps = [];
    if (stepper) {
      const existing = stepper.querySelectorAll(':scope > div');
      if (existing.length && existing.length !== total) {
        const template = existing[0];
        stepper.innerHTML = '';
        for (let i = 0; i < total; i++) {
          stepper.appendChild(template.cloneNode(true));
        }
      }
      steps = stepper.querySelectorAll(':scope > div');
    }

    function updateNextState() {
      const answered = answers[current] !== undefined;
      nextBtn.style.opacity = answered ? '' : '0.5';
      nextBtn.style.pointerEvents = answered ? '' : 'none';
      nextBtn.style.cursor = answered ? '' : 'not-allowed';
    }

    function render() {
      questions.forEach((q, i) => {
        if (i === current) {
          q.style.removeProperty('display');
        } else {
          q.style.setProperty('display', 'none', 'important');
        }
      });

      steps.forEach((step, i) => {
        step.style.background = i <= current ? ACTIVE_BG : '';
      });

      if (paginationEl) {
        paginationEl.textContent = current + 1 + ' de ' + total;
      }

      updateNextState();
    }

    // --- Cálculo del nivel según respuestas ---
    function computeLevelPercent() {
      let score = 0;
      let maxScore = 0;

      for (let q = 0; q < total; q++) {
        const weights = SCORING[q];
        if (!weights) continue; // pregunta que no puntúa

        maxScore += Math.max.apply(null, weights);

        const answer = answers[q];
        if (answer && weights[answer.index] !== undefined) {
          score += weights[answer.index];
        }
      }

      if (maxScore === 0) return MIN_WIDTH;

      const percent = (score / maxScore) * 100;
      return Math.max(MIN_WIDTH, Math.min(100, Math.round(percent)));
    }

    function applyLevel() {
      const percent = computeLevelPercent();

      const progressEl = quiz.querySelector('.custom-level-progress');
      const positionEl = quiz.querySelector('.custom-level-position');

      requestAnimationFrame(function () {
        if (progressEl) {
          progressEl.style.width = percent + '%';
        }
        if (positionEl) {
          positionEl.style.left = percent + '%';
        }
      });

      // Resalta el label correspondiente (Low / Normal / Medium / High)
      const barWrapper = progressEl ? progressEl.parentElement : null;
      const labelsWrapper = barWrapper ? barWrapper.nextElementSibling : null;
      if (labelsWrapper) {
        const labels = labelsWrapper.querySelectorAll(':scope > div');
        if (labels.length) {
          const levelIndex = Math.min(
            labels.length - 1,
            Math.floor((percent / 100) * labels.length)
          );
          labels.forEach((label, i) => {
            label.classList.toggle('custom-level-label-active', i === levelIndex);
          });
        }
      }
    }

    questions.forEach((question, qIndex) => {
      const options = question.querySelectorAll('.custom-quiz-options > div');

      options.forEach((option, oIndex) => {
        option.addEventListener('click', function () {
          options.forEach((o) => o.classList.remove('active'));
          option.classList.add('active');
          answers[qIndex] = { index: oIndex, text: option.textContent.trim() };

          if (qIndex === current) {
            updateNextState();
          }
        });
      });
    });

    nextBtn.addEventListener('click', function (e) {
      e.preventDefault();

      if (answers[current] === undefined) return;

      if (current < total - 1) {
        current++;
        render();
      } else {
        console.log('Respuestas seleccionadas:', answers);
        quiz.classList.add('ready');
        applyLevel();
      }
    });

    render();
  }

  function boot() {
    document.querySelectorAll('.custom-quiz-component').forEach(initQuiz);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  const observer = new MutationObserver(function () {
    const pending = document.querySelector(
      '.custom-quiz-component:not([data-quiz-init])'
    );
    if (pending) boot();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();